import { dateToLocalFormat } from 'helpers/dateToLocalFormat';
import { Link } from 'react-router-dom';
import './LastNewsCard.css';
import { useLanguage } from 'hooks/useLanguage';

/**
 * Картка новини — ADR-0005.
 *
 * Було: скляна картка з backdrop-filter, фіксованою висотою 27em і розкриттям
 * картинки по кліку на весь блок (клікабельний div без ролі).
 * Стало: посилання цілком, висота за вмістом, зображення в сталому співвідношенні.
 */
export default function LastNewsCard({ article }) {
  const language = useLanguage();
  const apiBase = process.env.REACT_APP_BASE_API_URL || '';

  if (!article) return null;

  const imageUrl = article.front?.url;
  const title = article.title;

  return (
    <Link className='last-news-card' to={`/news/${article.id}`}>
      <div className='news-img-wrapper'>
        {imageUrl ? (
          <img className='news-img' src={`${apiBase}${imageUrl}`} alt='' loading='lazy' />
        ) : (
          <span className='news-img-fallback' aria-hidden='true' />
        )}
      </div>

      <div className='news-card-body'>
        <time className='news-card-date tnum'>
          {dateToLocalFormat(article?.publicationDate || article.createdAt)}
        </time>
        <h3 className='news-card-title'>{title}</h3>
        <span className='news-card-more'>
          {language === 'en' ? 'Read' : 'Читати'}
          <svg className='btn-arrow' width='16' height='16' viewBox='0 0 24 24' aria-hidden='true'>
            <path
              d='M5 12h14M13 6l6 6-6 6'
              fill='none'
              stroke='currentColor'
              strokeWidth='1.6'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        </span>
      </div>
    </Link>
  );
}
